export default function hoverCard() {
  const cards = document.querySelectorAll('.teaser-card--hover');
  if (!cards.length) return;

  function init() {
    cards.forEach((card) => {
      setContentHeight(card);
      removeLoadingState(card);
    });
  }

  function setContentHeight(card) {
    const content = card.querySelector('.teaser-card__content');
    const header = card.querySelector('.teaser-card__header');
    const text = card.querySelector('.teaser-card__text');
    content.style.height = `${returnLargerElementHeight(header, text)}px`;
  }

  function removeLoadingState(card) {
    card.classList.remove('loading');
  }

  function returnComputedHeight(element) {
    return window.getComputedStyle(element).getPropertyValue('height');
  }

  function returnLargerElementHeight(element1, element2) {
    const element1Height = parseInt(returnComputedHeight(element1));
    const element2Height = parseInt(returnComputedHeight(element2));
    return element1Height > element2Height ? element1Height : element2Height;
  }

  init();
}

